<template>
    <div>
        <text-form-group
                v-model="data.line_one"
                name="line_one"
                label="Line One"
                :error="(errors.line_one || [])[0]"
        />

        <text-form-group
                v-model="data.line_two"
                name="line_two"
                label="Line Two"
                :error="(errors.line_two || [])[0]"
        />

        <text-form-group
                v-model="data.link_one_text"
                name="link_one_text"
                label="Link One Text"
                :error="(errors.link_one_text || [])[0]"
        />

        <text-form-group
                v-model="data.link_one_url"
                name="link_one_url"
                label="Link One URL"
                :error="(errors.link_one_url || [])[0]"
        />

        <text-form-group
                v-model="data.link_two_text"
                name="link_two_text"
                label="Link Two Text"
                :error="(errors.link_two_text || [])[0]"
        />

        <text-form-group
                v-model="data.link_two_url"
                name="link_two_url"
                label="Link Two URL"
                :error="(errors.link_two_url || [])[0]"
        />

        <gallery-form-group
                v-model="data.image_id"
                name="image_id"
                label="Image"
                :error="(errors.image_id || [])[0]"
        />
    </div>
</template>

<script>
    import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {GalleryFormGroup, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
